import PortfolioDataRoomNodes from './PortfolioDataRoomNodes.component';

export default PortfolioDataRoomNodes;
